import { useState } from "react"
import Popup from "./elements/Popup"

const Header = () => {
	const [showPopupPrice1, setShowPopupPrice1] = useState(false)
	const [showPopupPrice2, setShowPopupPrice2] = useState(false)
	const [showPopupPrice3, setShowPopupPrice3] = useState(false)

	return (
		<>
			<header className="relative z-0">
				<picture>
					<source media="(min-width: 768px)" srcSet={"/images/hero-destop.jpg"} />
					<img
						src={"/images/hero-mobile.jpg"}
						className=" block w-full"
						alt="Bulldog Men's Care und IRONMAN European Series 2026"
					/>
				</picture>

				<div
					className="absolute left-[49%] top-[67%] w-[30%] h-[12%] cursor-pointer block md:hidden "
					onClick={() => setShowPopupPrice1(true)}
				></div>
				<div
					className="absolute left-[25%] top-[79%] w-[30%] h-[12%] cursor-pointer block md:hidden "
					onClick={() => setShowPopupPrice2(true)}
				></div>
				<div
					className="absolute left-[60%] top-[83%] w-[30%] h-[12%] cursor-pointer block md:hidden "
					onClick={() => setShowPopupPrice3(true)}
				></div>
			</header>
			{showPopupPrice1 && (
				<Popup
					close={() => {
						setShowPopupPrice1(false)
					}}
				>
					<img
						src={"/images/popupMerch.png"}
						alt="Beispiel Kassenbon"
						className="  w-full max-w-[503px] mx-auto "
					/>
				</Popup>
			)}
			{showPopupPrice2 && (
				<Popup
					close={() => {
						setShowPopupPrice2(false)
					}}
				>
					<img
						src={"/images/popupStarterSet.png"}
						alt="Beispiel Kassenbon"
						className="  w-full max-w-[503px] mx-auto "
					/>
				</Popup>
			)}
			{showPopupPrice3 && (
				<Popup
					close={() => {
						setShowPopupPrice3(false)
					}}
				>
					<img
						src={"/images/popupRossmann_Gewinn.png"}
						alt="Beispiel Kassenbon"
						className="  w-full max-w-[503px] mx-auto "
					/>
				</Popup>
			)}
		</>
	)
}

export default Header
